<div class="contactCont h-auto py-5">

  <div class="contact_bx d-block mt-30 mt-lg-0" *ngIf="!formSubmitted">
    <span class="d-block text-gray-500 fs-5 mb-8">{{'YOUR_INFORMATION_WILL_BE_SAFE_AND_SECURE' | translate}}</span>
    <div class="row">
      <div class="col-12">
        <form [formGroup]="signupForm" (ngSubmit)="onSubmit($event)" class="form">
          <div class="form-group fv-plugins-icon-container">
            <div class="position-relative mb-4">
              <input class="form-control form-control-solid h-auto py-2 px-6" pInputText id="firstName"
                formControlName="firstName" type="text" [placeholder]="'FIRST_NAME' | translate" autocomplete="off"
                (keypress)="allowOnlyText($event)" pTooltip="{{ 'ENTER_YOUR_FIRST_NAME' | translate }}"
                tooltipPosition="right">
              <div class="fv-plugins-message-container"
                *ngIf="signupForm.controls['firstName'].touched && signupForm.controls['firstName'].invalid">
                <small class="text-danger" *ngIf="signupForm.controls['firstName'].errors?.['required'] || signupForm.controls['firstName'].errors?.['whitespace']">
                  {{'FIRST_NAME_IS_REQUIRED' | translate}}
                </small>
                <small class="text-danger" *ngIf="signupForm.controls['firstName'].errors?.['pattern']">
                  {{'FIRST_NAME_MUST_CONTAIN_ONLY_LETTERS' | translate}}
                </small>
              </div>
            </div>
          </div>
          <div class="form-group fv-plugins-icon-container">
            <div class="position-relative mb-4">
              <input class="form-control form-control-solid h-auto py-2 px-6" pInputText id="lastName"
                formControlName="lastName" type="text" [placeholder]="'LAST_NAME' | translate" autocomplete="off"
                (keypress)="allowOnlyText($event)" pTooltip="{{ 'ENTER_YOUR_LAST_NAME' | translate }}"
                tooltipPosition="right">
              <div class="fv-plugins-message-container"
                *ngIf="signupForm.controls['lastName'].touched && signupForm.controls['lastName'].invalid">
                <!-- Error message for required validation -->
                <small class="text-danger" *ngIf="signupForm.controls['lastName'].errors?.['required'] || signupForm.controls['lastName'].errors?.['whitespace']">
                  {{'LAST_NAME_IS_REQUIRED' | translate}}
                </small>
                <!-- Error message for pattern validation (i.e., invalid characters) -->
                <small class="text-danger" *ngIf="signupForm.controls['lastName'].errors?.['pattern']">
                  {{'LAST_NAME_MUST_CONTAIN_ONLY_LETTERS' | translate}}
                </small>
              </div>
            </div>
          </div>

          <div class="form-group fv-plugins-icon-container">
            <div class="position-relative mb-4">
              <input class="form-control form-control-solid h-auto py-2 px-6  " pInputText id="email"
                formControlName="email" type="email" [placeholder]="'EMAIL' | translate"
                pTooltip="{{ 'ENTER_YOUR_EMAIL' | translate }}" tooltipPosition="right" autocomplete="off">
              <div class="fv-plugins-message-container"
                *ngIf="signupForm.controls['email'].invalid && signupForm.controls['email'].touched">
                <small class="text-danger">{{'VALID_EMAIL_IS_REQUIRED'| translate}}</small>
              </div>
            </div>
          </div>

          <div class="form-group fv-plugins-icon-container">
            <div class="position-relative mb-4">
              <input class="form-control form-control-solid h-auto py-2 px-6" pInputText id="companyName"
                formControlName="companyName" type="text" [placeholder]="'COMPANY_NAME' | translate"
                pTooltip="{{ 'ENTER_YOUR_COMPANY_NAME' | translate }}" tooltipPosition="right" autocomplete="off">
              <div class="fv-plugins-message-container"
                *ngIf="signupForm.controls['companyName'].touched && signupForm.controls['companyName'].invalid">
                <small class="text-danger" *ngIf="signupForm.controls['companyName'].errors?.['required'] || signupForm.controls['companyName'].errors?.['whitespace']">
                  {{'COMPANY_NAME_IS_REQUIRED' | translate}}
                </small>
              </div>
            </div>
          </div>

          <!-- <div class="form-group fv-plugins-icon-container">
            <div class="position-relative mb-4">
              <input class="form-control form-control-solid h-auto py-2 px-6" pInputText id="licenceNumber"
                formControlName="licenceNumber" type="text" [placeholder]="'LICENCE_NUMBER' | translate"
                autocomplete="off">
              <div class="fv-plugins-message-container"
                *ngIf="signupForm.controls['licenceNumber'].touched && signupForm.controls['licenceNumber'].invalid">
                <small class="text-danger" *ngIf="signupForm.controls['licenceNumber'].errors?.['required']">
                  {{'LICENCE_NUMBER_IS_REQUIRED' | translate}}
                </small>
              </div>
            </div>
          </div> -->

          <div class="form-group fv-plugins-icon-container mb-4">
            <div class="countrycode_bx d-flex align-items-center">
              <p-dropdown class="country_code" appendTo="body" [options]="countryMaster" [(ngModel)]="selectedCountry"
                [ngModelOptions]="{standalone: true}" optionLabel="name" [placeholder]="'COUNTRY' | translate"
                [filter]="true" filterBy="name" required id="countryDropdown" name="countryDropdown"
                #countryDropdown="ngModel" (onChange)="onCountryChange($event)">
                <ng-template pTemplate="selectedItem">
                  <div class="d-flex align-items-center gap-2" *ngIf="selectedCountry">
                    <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                      [class]="'flag flag-' + selectedCountry.code.toLowerCase()" style="width: 18px" />
                    <div>+ {{ selectedCountry.phonecode }}</div>
                  </div>
                </ng-template>
                <ng-template let-country pTemplate="item">
                  <div class="d-flex align-items-center gap-2">
                    <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                      [class]="'flag flag-' + country.code.toLowerCase()" style="width: 18px" />
                    <!-- <div>+ {{ country.phonecode }}</div> -->
                    <div>{{ country.name }} (+{{ country.phonecode }})</div>
                  </div>
                </ng-template>
              </p-dropdown>
              <small *ngIf="showCountryCodeValidationBlock" class="text-danger">
                {{'PLEASE_SELECT_COUNTRY' | translate}}
              </small>
              <input class="form-control form-control-solid h-100 px-6" type="tel"
                [placeholder]="'MOBILE_NUMBER' | translate" name="phone_no" autocomplete="off" pattern="[0-9]*"
                inputmode="numeric" maxlength="10" formControlName="phone_no" (keypress)="allowOnlyNumbers($event)"
                pTooltip="{{ 'MOBILE_NUMBER_MUST_BE_10_DIGITS' | translate }}" tooltipPosition="right">
            </div>
            <small class="text-danger d-block" *ngIf="
                        (signupForm?.get('phone_no')?.errors?.['minlength'] ||
                        signupForm?.get('phone_no')?.errors?.['maxlength'] ||
                        signupForm?.get('phone_no')?.errors?.['pattern']) &&
                        signupForm?.get('phone_no')?.touched
                      ">
              {{ 'MOBILE_NUMBER_MUST_BE_10_DIGITS' | translate }}
            </small>
            <small class="text-danger d-block"
              *ngIf="signupForm?.get('phone_no')?.errors?.['required'] && signupForm?.get('phone_no')?.touched">
              {{'MOBILE_NUMBER_IS_REQUIRED' | translate}}
            </small>
          </div>

          <div class="form-group fv-plugins-icon-container mb-4">
            <textarea class="form-control form-control-solid h-auto py-2 px-6 " pInputTextarea formControlName="address"
              [placeholder]="'ENTER_YOUR_ADDRESS'  | translate" pTooltip="{{ 'ENTER_YOUR_ADDRESS' | translate }}"
              tooltipPosition="right"></textarea>
            <div class="fv-plugins-message-container"
              *ngIf="signupForm.controls['address'].invalid && signupForm.controls['address'].touched">
              <small class="text-danger" *ngIf="signupForm.controls['address'].errors?.['required'] || signupForm.controls['address'].errors?.['whitespace']">
                {{'ADDRESS_IS_REQUIRED' | translate}}
              </small>
            </div>
          </div>

          <div class="form-group position-relative fv-plugins-icon-container mb-4">
            <input class="form-control form-control-solid h-auto py-2 px-6 " pInputText formControlName="referralCode"
              type="text" [placeholder]="'REFERRAL_CODE'  | translate" pTooltip="{{ 'ENTER_REFERAL_CODE' | translate }}"
              tooltipPosition="right" autocomplete="off">
          </div>

          <div class="form-group d-flex position-relative flex-wrap justify-content-center align-items-center">
            <button pButton pRipple type="submit" class="btn btn-primary font-weight-bold px-9 py-2 my-3"
              [disabled]="signupForm.invalid">{{'SUBMIT' | translate}}</button>
          </div>
          <input type="hidden">
          <div></div>
        </form>
      </div>
    </div>
  </div>

  <!-- Thank you section -->
  <div class="d-flex flex-column flex-center bg-light text-center rounded-3 p-5 py-8" *ngIf="formSubmitted">
    <div class="d-flex flex-center w-60px h-60px rounded-3 bg-light-success bg-opacity-90 mb-4">
      <i class="fa fa-smile-o text-success fs-3x"></i>
    </div>
    <h2 class="fs-3 fw-bold text-capitalize lh-base">{{'THANK_YOU_FOR_REACHING_OUT' | translate}} <br>
      {{"WE_WILL_GET_BACK_TO_YOU_SOON" | translate}}</h2>
  </div>
</div>
